import nacl from "tweetnacl";

/**
 * Generates a new ephemeral keypair for anonymous communication.
 *
 * @returns An object with `publicKey` and `privateKey` as Uint8Arrays (32 bytes each).
 */
export function generateEphemeralKeypair(): {
  publicKey: Uint8Array;
  privateKey: Uint8Array;
} {
  const keypair = nacl.box.keyPair();

  return {
    publicKey: keypair.publicKey,
    privateKey: keypair.secretKey,
  };
}